export default __webpack_public_path__ + "static/media/leaf-svgrepo-com.a36a6f36.svg";